/**
 * googleTagManager constants
 */
export const DISPATCH_EVENT = 'DISPATCH_EVENT';
export const OH_WEB_EVENT = 'ORCHARDHAND_WEB_EVENT';
